export default function PageHeader({icon, title, subtitle, content}) {
  return (
    <header
      className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
      <div className="container-xl px-4">
        <div className="page-header-content pt-4">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto mt-4">
              <h1 className="page-header-title">
                {icon && <div className="page-header-icon">{icon}</div>}
                {title}
              </h1>
              {subtitle &&
                <div className="page-header-subtitle">{subtitle}</div>}
            </div>
            {content && <div className="col-12 col-xl-auto mt-4">
              {content}
            </div>}
          </div>
        </div>
      </div>
    </header>
  );
}
